import { DataOption } from '../../components'

export const AmazonDataOptions = [
  // { type: 'profiles', label: 'Profiles' },
  { type: 'sponsored_brands_campaigns', label: 'Brands Campaigns' },
  { type: 'sponsored_brands_ad_groups', label: 'Brands Ad Groups' },
  // { type: 'sponsored_brands_keywords', label: 'Brands Keywords' },
  { type: 'sponsored_display_ad_groups', label: 'Display Ad Groups' },
  { type: 'sponsored_display_campaigns', label: 'Display Campaigns' },
  { type: 'sponsored_display_product_ads', label: 'Display Product Ads' },
  // { type: 'sponsored_display_targetings', label: 'Display Targetings' },
  { type: 'sponsored_product_ad_groups', label: 'Product Ad Groups' },
  { type: 'sponsored_product_ads', label: 'Product Ads' },
  { type: 'sponsored_product_campaigns', label: 'Product Campaigns' },
  // { type: 'sponsored_product_keywords', label: 'Product Keywords' },
  // { type: 'sponsored_product_negative_keywords', label: 'Product Negative Keywords' },
  // { type: 'sponsored_product_targetings', label: 'Product Targetings' },
] as const satisfies DataOption[]

export const AMAZON_DATA_TYPE_KEY = 'data_type'
